module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "teacher_research"
    }
  }, [_c('div', {
    staticClass: "over_ta"
  }, [_c('ul', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, _vm._l((_vm.teacherpublications), function(teacherpublication, index) {
    return (teacherpublication.type === 4) ? _c('li', {
      key: index,
      staticStyle: {
        "list-style": "inside"
      }
    }, [(teacherpublication.context) ? _c('span', [_vm._v("\n          " + _vm._s(teacherpublication.context) + "\n        ")]) : _c('span', [(_vm.executiveDateS(teacherpublication)) ? _c('span', [_vm._v(_vm._s(_vm.executiveDateS(teacherpublication)) + " ~ " + _vm._s(_vm.executiveDateE(teacherpublication)) + ", ")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.showName(teacherpublication)) + ", "), (teacherpublication.memo) ? _c('span', [_vm._v("(" + _vm._s(teacherpublication.memo) + ")")]) : _vm._e()])]) : _vm._e()
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44660b46","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/TeacherResearch.vue
// module id = 1246
// module chunks = 4